import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormArray, FormControl, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'size-mapping',
    templateUrl: './size-mapping.component.html',
    styleUrls: ['./size-mapping.component.scss'],
    standalone: false
})
export class SizeMappingComponent implements OnInit, OnChanges {
    @Input() coverTypes: [];
    @Input() bookingTypes: any[];
    @Input() maxSize: number = 61;
    @Input() minSize: number = 1;
    @Input() dataCovers;
    @Input() dataSize;
    @Input() isEdit;

    @Output() sizeChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() size: {
        valid: boolean;
        sizes: any
    };


    mappedTypes: any[] = [];
    coverTypeName: {
        [key: string]: string
    } = {};
    bookingTypeName: {
        [key: string]: string
    } = {};

    sizeArr: number[] | string[] = Array.from(Array(61).keys());
    formGroup = new UntypedFormGroup({})
    errors: string[];

    constructor(private translateService: TranslateService) {

    }

    ngOnInit() {
        this.mappedTypes = [];
        this.sizeArr = Array.from(Array(this.maxSize + 1).keys());
        this.setConfigTypes();
   }

    ngOnChanges(changes: SimpleChanges){
        if(changes.bookingTypes || changes.coverTypes || changes.dataCovers){
            this.mappedTypes = [];
            this.setConfigTypes();
            this.sizeChange.emit({ sizes: this.mappedTypes, valid: !this.formValidate().length, errors: this.errors });
        }
    }

    setConfigTypes(){
        let coverObject = {};
        if(this.dataCovers && this.dataCovers.length){
            this.dataCovers.forEach(({CoverTypeId, BookingTypeId, Covers}) => {
                coverObject[(CoverTypeId || null) + "_" + (BookingTypeId || null)] = Covers
            });
        }
        this.bookingTypes.forEach(bookingType => {
            this.bookingTypeName[bookingType.id] = bookingType.name || bookingType.Name;
        })
        this.coverTypes.forEach((coverType: any) => {
            this.coverTypeName[coverType.id || coverType.CoverTypeId] = coverType.name || coverType.Name || coverType.CoverTypeName;
        })

        if(!this.bookingTypes.length){
            this.bookingTypes = [{id: 0}]
        }

        if (this.bookingTypes?.length) {
            this.bookingTypes.forEach((bookingtype, bIndex) => {
                if (this.coverTypes?.length) {
                    this.coverTypes.forEach((cover: any) => {
                        this.mappedTypes.push(this.getTypeObj(bookingtype.id, cover.id, bIndex === 0 ? (cover.value || 0) : 0 ));
                    })

                    if(!this.mappedTypes.find(mappedType => mappedType.Covers)){
                        this.mappedTypes[0].Covers = this.minSize || 1;
                    }
                } else {
                    this.mappedTypes.push(this.getTypeObj(bookingtype.id, null, bIndex === 0 ? (this.minSize || 1) : 0));
                }
            })
        }

        if(this.dataCovers && this.dataCovers.length){
            this.mappedTypes.forEach(type => {
                type.Covers = coverObject[(type.CoverTypeId || null) + "_" + (type.BookingTypeId || null)] || 0;
            })
        }
        else {
            if(this.isEdit)
        this.mappedTypes.forEach(type => {
            type.Covers = this.dataSize || 0;
        })
    }

    }

    getTypeObj(BookingTypeId, CoverTypeId, defaultSize){
        return {
            BookingTypeId: BookingTypeId,
            BookingTypeName: this.bookingTypeName[BookingTypeId],
            CoverTypeId: CoverTypeId,
            CoverTypeName: this.coverTypeName[CoverTypeId],
            Covers: defaultSize
        }
    }

    parySizeChange(updateValue,cover) {
        if(updateValue == 'prev' && cover.Covers == 0) {
            return ;
        }
        if(updateValue == 'prev' && cover.Covers > 0) {
            cover.Covers = cover.Covers - 1;
        }
        else if(updateValue == 'next' && cover.Covers < this.maxSize) {
            cover.Covers = cover.Covers + 1;
        }
       this.onSizeChange();

    }

    onSizeChange() {
        this.errors = this.formValidate();
        this.sizeChange.emit({ sizes: this.mappedTypes, valid: !this.errors.length, errors: this.errors });
    }

    formValidate(): string[] {
        let coverTypeQuantities = {};
        let totalQuantity = 0;
        this.mappedTypes.forEach(type => {
            if (!coverTypeQuantities[type.CoverTypeId]) {
                coverTypeQuantities[type.CoverTypeId] = 0;
            }

            coverTypeQuantities[type.CoverTypeId] += +type.Covers;
            totalQuantity += +type.Covers
        });

        let errors = [];
        if(!totalQuantity|| (totalQuantity < this.minSize)){
            errors.push(this.translateService.instant('guestTypeMinQuantityErrorMessage', {quantity: this.minSize, guestType: this.translateService.instant('cover')}))
        }else if(this.coverTypes.length){
            this.coverTypes.forEach((cover: any) => {
                if (coverTypeQuantities[cover.Id] < cover.MinimumQuantity) {
                    errors.push(this.translateService.instant('guestTypeMinQuantityErrorMessage', {quantity: cover.MinimumQuantity, guestType: cover.Name}))
                }
            })
        }
        if(totalQuantity > this.maxSize){
            errors.push(this.translateService.instant('maxPartySizeError', {maxPartySize: this.maxSize}))
        }

        return errors
    }
}


import { Pipe, PipeTransform, OnChanges } from "@angular/core";

@Pipe({
    name: 'groupBy',
    standalone: false
})
  export class GroupByPipe implements PipeTransform {
  
    transform(arr: any[], groupBy:string): any {
        const grouped = new Map<any, any[]>();
        const keyOrder: any[] = [];
        // Group items while preserving the order of first occurrence
        for (const item of arr) {
            const key = item[groupBy];
            if (!grouped.has(key)) {
                grouped.set(key, []);
                keyOrder.push(key);
            }
            grouped.get(key)?.push(item);
        }
        // Return as array of [key, values] tuples in the order keys were first encountered
        return keyOrder.map(key => [key, grouped.get(key)]);
    }
  }